var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_BACKGROUND_COLOR } from '../common';
export const setAlignment = (container, alignment) => {
    if (alignment && alignment === 'left') {
        container.classList.add('has-left-alignment');
    }
};
export const hasClass = (element, cls) => {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
};
export const getWidgetSettings = (paramsServer, clientId) => __awaiter(void 0, void 0, void 0, function* () {
    const protocol = paramsServer.includes('localhost:') ? 'http://' : 'https://';
    const url = `${protocol}${paramsServer}/widget/settings`;
    const response = yield fetch(url, { headers: { 'client-id': clientId.toString() } }).catch((error) => console.error('Error', error));
    return response === null || response === void 0 ? void 0 : response.json();
});
const getClosedChatIcon = (color) => `
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="${color}"/>
    <path d="M28 15C35.1796 15 41 20.8205 41 28.0002C41 31.5904 39.545 34.8403 37.1925 37.1921L40.1466 40.1465C40.4615 40.4615 40.2384 41 39.793 41H28C20.8204 41 15 35.18 15 27.9998C15 20.82 20.8199 15 28 15Z" fill="white"/>
    <circle cx="22.75" cy="28" r="1.75" fill="${color}"/>
    <circle cx="28" cy="28" r="1.75" fill="${color}"/>
    <circle cx="33.25" cy="28" r="1.75" fill="${color}"/>
  </svg>
`;
const getOpenedChatIcon = (color) => `
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28" cy="28" r="28" fill="${color}"/>
    <path d="M35.5 26L28 33.5L20.5 26" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;
export const setButtonIcon = (button, color = DEFAULT_BACKGROUND_COLOR) => (isOpen) => {
    if (!button)
        return;
    button.innerHTML = isOpen ? getOpenedChatIcon(color) : getClosedChatIcon(color);
};
